'use client';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { FaFacebookF, FaLinkedin } from 'react-icons/fa';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const BlogShare = ({ blog }: { blog: Blog }) => {
  const { t } = useTranslations();
  const baseUrl = process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3000'; // Fallback to localhost if the env variable is not set
  const url = `${baseUrl}${blog.slug}`;

  const handleFacebookShare = () => {
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url,
    )}&quote=${encodeURIComponent(blog.name)}`;
    window.open(facebookShareUrl, '_blank', 'noopener,noreferrer');
  };

  const handleLinkedInShare = () => {
    const linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      url,
    )}`;
    window.open(linkedInShareUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="flex items-center justify-end gap-2 sm:gap-4">
      <p className="text-sm font-normal text-foreground sm:text-base">{t('text229')}:</p>
      <div className="flex items-center justify-end gap-2">
        <span
          onClick={handleFacebookShare}
          className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-primary text-white transition-all hover:bg-primary/90 sm:h-10 sm:w-10"
        >
          <FaFacebookF className="h-4 w-4" />
        </span>
        <span
          onClick={handleLinkedInShare}
          className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-primary text-white transition-all hover:bg-primary/90 sm:h-10 sm:w-10"
        >
          <FaLinkedin className="h-4 w-4" />
        </span>
      </div>
    </div>
  );
};
